import { html } from "lit";

export const formMockHtml = html`
    <div class="ax_default heading_2">
        <div class="text">
            <p><span>Ihre Daten</span></p>
        </div>
    </div>
    <div class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-salutation"
            style="height: 30.8px;"
        >
            Anrede
        </label>
        <div class="select select-field">
            <span class="icon-arrow_down select-icon"></span>
            <select
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class="powermail_field form-control "
                id="powermail_field_webinarTestform-968533-salutation"
                name="tx_form_formframework[webinarTestform-968533][salutation]"
            >
                <option value="">Bitte wählen ...</option>
                <option value="2">Herr</option>
                <option value="1">Frau</option>
                <option value="3">Divers</option>
            </select>
        </div>
    </div>
    <div
        class="powermail_fieldwrap powermail_fieldwrap_type_gap no-gutter-left gr-6 gr-12@m"
    ></div>
    <div class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-firstname"
            style="height: 30.8px;"
        >
            Vorname
        </label>
        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-firstname"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][firstname]"
                value=""
            />
        </div>
    </div>
    <div class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-lastname"
            style="height: 30.8px;"
        >
            Nachname
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-lastname"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][lastname]"
                value=""
            />
        </div>
    </div>

    <input
        autocomplete="CgBqplt2uvbY0ro3RJNfEO51Zm"
        aria-hidden="true"
        id="webinarTestform-968533-CgBqplt2uvbY0ro3RJNfEO51Zm"
        style="position:absolute; margin:0 0 0 -999em;"
        tabindex="-1"
        type="text"
        name="tx_form_formframework[webinarTestform-968533][CgBqplt2uvbY0ro3RJNfEO51Zm]"
    />

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-company"
            style="height: 30.8px;"
        >
            Firma
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-company"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][company]"
                value=""
            />
        </div>
    </div>

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-streetno"
            style="height: 30.8px;"
        >
            Straße und Nr.
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-streetno"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][streetno]"
                value=""
            />
        </div>
    </div>

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-zip"
            style="height: 30.8px;"
        >
            PLZ
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-zip"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][zip]"
                value=""
            />
        </div>
    </div>

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-place"
            style="height: 30.8px;"
        >
            Ort
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-place"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][place]"
                value=""
            />
        </div>
    </div>

    <div
        class="powermail_fieldwrap powermail_fieldwrap_type_select powermail_fieldwrap_countrylist no-gutter-left gr-12"
    >
        <label
            for="powermail_field_638624_webinarTestform-968533-countrylist"
            class="powermail_fieldwrap__label  label-errorMsg"
            title=""
            style="height: 30.8px;"
        >
            Land/Region
        </label>

        <div class="powermail_fieldwrap">
            <input
                readonly="readonly"
                onfocus="this.removeAttribute('readonly');"
                class="select select-field powermail_field_countrylist form-control ui-autocomplete-input"
                id="powermail_field_638624_webinarTestform-968533-countrylist"
                type="text"
                name="tx_form_formframework[countrylist]"
                autocomplete="off"
            />

            <span class="hide">
                <input
                    data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                    class="select select-field"
                    id="countryiso_638624"
                    type="text"
                    name="tx_form_formframework[webinarTestform-968533][countrylist]"
                    value=""
                />
            </span>
        </div>
    </div>
    <script>
        var mandatory = false;
        var inputCountriesName = "countrylist";
        var hiddenFieldId = "638624";
        if (typeof formId === "undefined") {
            var formId = ["638624"];
        } else {
            formId.push("638624");
        }

        var availableCountries = [];
        availableCountries["AL"] = "Albanien";
        availableCountries["DZ"] = "Algerien";
        availableCountries["AR"] = "Argentinien";
        availableCountries["AU"] = "Australien";
        availableCountries["BH"] = "Bahrain";
        availableCountries["BE"] = "Belgien";
        availableCountries["BR"] = "Brasilien";
        availableCountries["BG"] = "Bulgarien";
        availableCountries["CL"] = "Chile";
        availableCountries["CN"] = "China";
        availableCountries["CR"] = "Costa Rica";
        availableCountries["DE"] = "Deutschland";
        availableCountries["DK"] = "Dänemark";
        availableCountries["EE"] = "Estland";
        availableCountries["FI"] = "Finnland";
        availableCountries["FR"] = "Frankreich";
        availableCountries["GR"] = "Griechenland";
        availableCountries["IN"] = "Indien";
        availableCountries["ID"] = "Indonesien";
        availableCountries["IQ"] = "Irak";
        availableCountries["IR"] = "Iran";
        availableCountries["IE"] = "Irland";
        availableCountries["IS"] = "Island";
        availableCountries["IL"] = "Israel";
        availableCountries["IT"] = "Italien";
        availableCountries["JP"] = "Japan";
        availableCountries["JO"] = "Jordanien";
        availableCountries["KH"] = "Kambodscha";
        availableCountries["CA"] = "Kanada";
        availableCountries["QA"] = "Katar";
        availableCountries["KE"] = "Kenia";
        availableCountries["CO"] = "Kolumbien";
        availableCountries["HR"] = "Kroatien";
        availableCountries["KW"] = "Kuwait";
        availableCountries["LV"] = "Lettland";
        availableCountries["LB"] = "Libanon";
        availableCountries["LI"] = "Liechtenstein";
        availableCountries["LT"] = "Litauen";
        availableCountries["LU"] = "Luxemburg";
        availableCountries["MY"] = "Malaysia";
        availableCountries["MT"] = "Malta";
        availableCountries["MA"] = "Marokko";
        availableCountries["MX"] = "Mexiko";
        availableCountries["MM"] = "Myanmar";
        availableCountries["NZ"] = "Neuseeland";
        availableCountries["NL"] = "Niederlande";
        availableCountries["MK"] = "Nordmazedonien";
        availableCountries["NO"] = "Norwegen";
        availableCountries["PK"] = "Pakistan";
        availableCountries["PS"] = "Palästinensische Autonomiegebiete";
        availableCountries["PE"] = "Peru";
        availableCountries["PH"] = "Philippinen";
        availableCountries["PL"] = "Polen";
        availableCountries["PT"] = "Portugal";
        availableCountries["RO"] = "Rumänien";
        availableCountries["RU"] = "Russland";
        availableCountries["SA"] = "Saudi-Arabien";
        availableCountries["SE"] = "Schweden";
        availableCountries["CH"] = "Schweiz";
        availableCountries["RS"] = "Serbien";
        availableCountries["SG"] = "Singapur";
        availableCountries["SK"] = "Slowakei";
        availableCountries["SI"] = "Slowenien";
        availableCountries["HK"] = "Sonderverwaltungsregion Hongkong";
        availableCountries["ES"] = "Spanien";
        availableCountries["SY"] = "Syrien";
        availableCountries["ZA"] = "Südafrika";
        availableCountries["KR"] = "Südkorea";
        availableCountries["TW"] = "Taiwan";
        availableCountries["TH"] = "Thailand";
        availableCountries["CZ"] = "Tschechien";
        availableCountries["TN"] = "Tunesien";
        availableCountries["TR"] = "Türkei";
        availableCountries["UA"] = "Ukraine";
        availableCountries["HU"] = "Ungarn";
        availableCountries["UY"] = "Uruguay";
        availableCountries["VE"] = "Venezuela";
        availableCountries["AE"] = "Vereinigte Arabische Emirate";
        availableCountries["US"] = "Vereinigte Staaten";
        availableCountries["GB"] = "Vereinigtes Königreich";
        availableCountries["VN"] = "Vietnam";
        availableCountries["EG"] = "Ägypten";
        availableCountries["AT"] = "Österreich";
        availableCountries["OO"] = "Andere";
        require(["minified/form/_countrylist.min"], function (countrylist) {
            countrylist.init();
            var countryVal = $("#countryiso_" + hiddenFieldId).val();
            if (countryVal) {
                $(".powermail_field_" + inputCountriesName).val(
                    availableCountries[countryVal]
                );
            }
        });
    </script>

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-email"
            style="height: 30.8px;"
        >
            E-Mail

            <span class="required">*</span>
        </label>

        <div class="powermail_fieldwrap input">
            <input
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                class=" form-control"
                id="webinarTestform-968533-email"
                type="text"
                name="tx_form_formframework[webinarTestform-968533][email]"
                value=""
            />
        </div>
    </div>

    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <label
            class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
            for="webinarTestform-968533-message"
            style="height: 30.8px;"
        >
            Ihre Nachricht

            <span class="required">*</span>
        </label>
        <div class="powermail_fieldwrap input">
            <textarea
                placeholder=""
                data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                rows="5"
                cols="20"
                class="xxlarge form-control"
                id="webinarTestform-968533-message"
                name="tx_form_formframework[webinarTestform-968533][message]"
            ></textarea>
        </div>
    </div>
    <div class="powermail_fieldwrap no-gutter-left form-group  gr-12">
        <div class="powermail_fieldwrap input">
            <div
                class="form-check powermail_fieldwrap_type_check powermail_newsletter_subscription no-gutter-left gr-12"
            >
                <input
                    type="hidden"
                    name="tx_form_formframework[webinarTestform-968533][newsletter]"
                    value=""
                /><input
                    data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                    class="add-on powermail_input"
                    id="powermail_field_newsletter_0"
                    type="checkbox"
                    name="tx_form_formframework[webinarTestform-968533][newsletter]"
                    value="1"
                    data-parsley-multiple="tx_form_formframeworkwebinarTestform-968533newsletter"
                />
                <label
                    for="checkbox"
                    class="label_newsletter_subscription label-errorMsg"
                    >Ich bin damit einverstanden, dass die TRUMPF Gruppe meine
                    zuvor angegebenen Daten zum Zwecke der Marktforschung,
                    Werbung und Analyse verarbeitet und mich zu diesen Zwecken
                    per Post, E-Mail und Telefon kontaktiert, um mich über
                    eigene aktuelle Angebote und Services zu informieren.
                    <br /><br />Ich kann diese Einwilligung jederzeit, auch
                    teilweise, unter
                    <a href="mailto:mailings_holding@de.trumpf.com"
                        >mailings_holding@de.trumpf.com</a
                    >
                    widerrufen.
                    <br />
                    <span
                        class="powermail_field_error_container powermail_field_error_container_ label-errorMsg"
                    ></span>
                    <br />
                    Mehr zum Thema Datenschutz bei TRUMPF finden Sie in unserer
                    <a href="/de_INT/meta/datenschutz/">Datenschutzerklärung</a
                    >.
                    <br />
                </label>
            </div>
            <br />
        </div>
    </div>

    <input
        id="webinarTestform-968533-additionalinfo"
        type="hidden"
        name="tx_form_formframework[webinarTestform-968533][additionalinfo]"
        value='{"pageUid":2920,"referrer":"http%3A%2F%2Ftrumpf.local.tru%2Ftypo3%2Fmodule%2Fweb%2Flayout%3Ftoken%3D3d3cb3eca31704b59502812c5d84619083f0497f%26id%3D2920%26","siteurl":"http%3A%2F%2Ftrumpf.local.tru%2Fde_INT%2Fcontent-elemente%2F","ttContentUid":968533}'
    />
`;
